import { Grid, Typography, Alert, Button } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Wildfire } from 'features/wildfires/wildfire.types';

const newLineSx = {
  whiteSpace: 'pre-line',
  wordBreak: 'break-word',
} as const;

type WildfireAutomatedDisclaimerProps = {
  wildfire: Wildfire;
};

export const WildfireAutomatedDisclaimer = (
  props: WildfireAutomatedDisclaimerProps,
): JSX.Element => {
  const {
    wildfire: {
      createdByName: { displayName, abbreviationName },
      userCreatedId,
    },
  } = props;
  const { t } = useTranslation();

  const shortNameWrapped = abbreviationName ? ` (${abbreviationName})` : '';

  return (
    <Grid container spacing={2} sx={{ width: '100%' }} data-testid="evacInfo">
      <Grid size={12}>
        <Alert
          icon={false}
          severity="warning"
          sx={{
            '& .MuiAlert-message': { width: '100%' },
          }}
        >
          <Grid container spacing={2} sx={{ width: '100%' }}>
            <Grid size={12}>
              <Typography sx={newLineSx}>
                <Trans
                  i18nKey="geoEvent.automatedDisclaimer.updates"
                  values={{ displayName, shortNameWrapped }}
                  shouldUnescape
                >
                  All updates for this incident are automated and provided by:
                  <b>{displayName}</b>
                  {shortNameWrapped}.
                </Trans>
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography sx={newLineSx}>
                <Trans i18nKey="geoEvent.automatedDisclaimer.notMonitoring">
                  Watch Duty reporters are
                  <b>not actively monitoring this incident</b>.
                </Trans>
              </Typography>
            </Grid>
            <Grid size={12}>
              <Button
                component={Link}
                variant="watchduty-text-uppercase"
                to={`/profile/${userCreatedId}#allow-back`}
                sx={{
                  color: 'text.primary',
                }}
              >
                {t('geoEvent.evacuation.learnMore')}
              </Button>
            </Grid>
          </Grid>
        </Alert>
      </Grid>
    </Grid>
  );
};
